var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "grid-view" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.view === "list",
                  expression: "view==='list'"
                }
              ],
              staticClass: "main-content"
            },
            [
              _c(
                "search-item",
                {
                  ref: "searchItem",
                  attrs: {
                    "config-module": "119214",
                    "expand-adv": true,
                    "show-simple": false,
                    "custom-search-items": _vm.customSearchItems
                  },
                  on: { advSearchItemCallBack: _vm.queryHandler }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            disabled: !_vm.selectedRow,
                            no: "view"
                          },
                          on: { click: _vm.detail }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.selectedRow || _vm.selectedRow.status === 2,
                            no: "edit"
                          },
                          on: { click: _vm.edit }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "add" },
                          on: { click: _vm.add }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "revoke" },
                          on: { click: _vm.revoke }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Revoke")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Clone" },
                          on: {
                            click: function($event) {
                              return _vm.copy()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "print" },
                          on: { click: _vm.toPrint }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
                [
                  _c("cargo-ag-grid-wrapper", {
                    staticStyle: { height: "100%" },
                    attrs: {
                      "config-module": "2025050261",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "show-selected-color": false,
                      "check-sub-record": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "2025050261",
                      total: _vm.filter.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: _vm.fetchDataByPage
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.view === "detail"
            ? _c("inquiry-sea-fcl-detail", {
                ref: "inquiryDetail",
                attrs: { source: "CarFormTab" },
                on: {
                  loadSalesPrivateCustomer: _vm.loadSalesPrivateCustomer,
                  back: _vm.back,
                  cancel: function($event) {
                    _vm.view = "list"
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }